import './src/styles/variables.module.css';
import './src/styles/typography.module.css';
import './src/styles/global.css';
import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import Page from './src/components/layout/Page';
import PreconSupporterPage from './src/components/layout/precon-supporter/PreconSupporterPage';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  const pathname = props.location?.pathname || '';
  // /precon-supporter/yousei-kouza または /prs/{PR番号}/precon-supporter/yousei-kouza を判定
  const isPreconSupporterPage =
    pathname.startsWith('/precon-supporter/yousei-kouza') ||
    /^\/prs\/\d+\/precon-supporter\/yousei-kouza/.test(pathname);

  if (isPreconSupporterPage) {
    return <PreconSupporterPage element={element} props={props} />;
  }

  return <Page element={element} props={props} />;
};
